import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * /c/<code> — the link a media partner puts in an ad.
 *
 * It exists to do one thing fast: log the tap with whatever click id the platform appended
 * (fbclid, gclid, ttclid, li_fat_id…), then hand the visitor to the application form with the
 * attribution attached. No tracking scripts, no third-party pixels — the ad platform gets its
 * conversion back from us, server to server.
 */
export default function CampaignRedirect() {
  const { code } = useParams();
  const [err, setErr] = useState(null);
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    api.post(`/apply/click/${code}`, {
      query: window.location.search || null,
      referrer: document.referrer || null,
    })
      .then((r) => {
        const url = r.data?.url || "/business-funding";
        try { sessionStorage.setItem("cx_ck", r.data?.click || ""); } catch { /* private mode */ }
        window.location.replace(url);
      })
      .catch(() => {
        // A retired code should still land somewhere useful rather than on an error
        setErr(true);
        setTimeout(() => window.location.replace("/business-funding"), 1400);
      });
  }, [code]);

  return (
    <div data-testid="campaign-redirect" style={{
      minHeight: "100vh", display: "grid", placeItems: "center", background: "#0B1220", color: "#E2E8F0",
      fontFamily: "'Instrument Sans', system-ui, sans-serif", padding: 24, textAlign: "center",
    }}>
      <div>
        <style>{`@keyframes cxspin{to{transform:rotate(360deg)}}`}</style>
        <div style={{ width: 34, height: 34, margin: "0 auto 18px", borderRadius: "50%",
                      border: "2.5px solid rgba(125,169,255,.25)", borderTopColor: "#7DA9FF",
                      animation: "cxspin .8s linear infinite" }} />
        <div style={{ fontSize: 15, fontWeight: 600 }}>
          {err ? "Taking you to business funding…" : "One moment — opening your application"}
        </div>
        <div style={{ marginTop: 8, fontSize: 12.5, color: "#64748B" }}>Connexis Group</div>
      </div>
    </div>
  );
}
